<template>
  <div class="sub-batch">
    <b-table v-if="tabIndex === 0" :items="items" :fields="subStartFields" primary-key="id">
      <template class="busy-row" v-slot:table-busy>
        <div class="vld-parent spinner-row text-center">
          <loading :active.sync="isBusy"
          :can-cancel="false"
          :color="'#047bf8'"
          :loader="'dots'"
          :is-full-page="false"></loading>
        </div>
      </template>
      <template v-slot:empty="scope">
        <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
      </template>
      <template v-slot:cell(id)="data">
        <span v-if="data.item.test_mode" class="text-danger">{{ data.item.id }}</span>
        <span v-else>{{ data.item.id }}</span>
      </template>
      <template v-slot:cell(batch_status)="data">
        <span>{{ data.item.status }}</span>
      </template>
      <template v-slot:cell(reference)="data">
        <span class="font-italic">{{ data.item.reference }}</span>
      </template>
      <template v-slot:cell(start_dataxferred_docs)="data">
        <span>{{ data.item.total.start_dataxferred_docs.value }} </span>
        <!--<span>({{ data.item.total.start_dataxferred_docs.percentage}}%)</span>-->
      </template>
      <template v-slot:cell(start_emailed_docs)="data">
        <span>{{ data.item.total.start_emailed_docs.value }} </span>
        <!--<span>({{ data.item.total.start_emailed_docs.percentage}}%)</span>-->
      </template>
      <template v-slot:cell(start_faxed_docs)="data">
        <span>{{ data.item.total.start_faxed_docs.value }} </span>
        <!--<span>({{ data.item.total.start_faxed_docs.percentage}}%)</span>-->
      </template>
      <template v-slot:cell(start_posted_docs)="data">
        <span>{{ data.item.total.start_posted_docs.value }} </span>
        <!--<span>({{ data.item.total.start_posted_docs.percentage}}%)</span>-->
      </template>
      <template v-slot:cell(start_online_docs)="data">
        <span>{{ data.item.total.start_online_docs.value }} </span>
        <!--<span>({{ data.item.total.start_online_docs.percentage}}%)</span>-->
      </template>
      <template v-slot:cell(deleted_docs)="data">
        <span>{{ data.item.total.deleted_docs.value }} </span>
        <!--<span>({{ data.item.total.deleted_docs.percentage}}%)</span>-->
      </template>
      <template v-slot:cell(start_total_docs)="data">
        <span>{{ data.item.total.start_total_docs.value }} </span>
        <!--<span>({{ data.item.total.start_total_docs.percentage}}%)</span>-->
      </template>
      <template v-slot:cell(start_failed_dataxferred_docs)="data">
        <span></span>
      </template>
      <template v-slot:cell(start_failed_emailed_docs)="data">
        <span></span>
      </template>
      <template v-slot:cell(start_failed_faxed_docs)="data">
        <span></span>
      </template>
      <template v-slot:cell(start_failed_total_docs)="data">
        <span></span>
      </template>
      <template v-slot:cell(documents_link)="data">
        <span></span>
      </template>
      <template v-slot:cell(added_on)="data">
        <span>{{ t('uploadedOn', 'uploadedOn') }} </span> <span>{{ data.item.added_on | clientDateFormat(datePickerFormat) }}</span>
      </template>
      <template v-slot:row-details="row">
        <SubStatus v-if="row.item.sub_batch" :items="row.item.sub_batch"/>
      </template>
    </b-table>
    <b-table v-if="tabIndex === 1" :items="items" :fields="subFinalFields" primary-key="id">
      <template class="busy-row" v-slot:table-busy>
        <div class="vld-parent spinner-row text-center">
          <loading :active.sync="isBusy"
          :can-cancel="false"
          :color="'#047bf8'"
          :loader="'dots'"
          :is-full-page="false"></loading>
        </div>
      </template>
      <template v-slot:empty="scope">
        <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
      </template>
      <template v-slot:cell(id)="data">
        <span v-if="data.item.test_mode" class="text-danger">{{ data.item.id }}</span>
        <span v-else>{{ data.item.id }}</span>
      </template>
      <template v-slot:cell(batch_status)="data">
        <span>{{ data.item.status }}</span>
      </template>
      <template v-slot:cell(reference)="data">
        <span class="font-italic">{{ data.item.reference }}</span>
      </template>
      <template v-slot:cell(final_dataxferred_docs)="data" >
        <span>{{ data.item.total.final_dataxferred_docs.value }}</span>
        <!--<span>{{ data.item.total.final_dataxferred_docs.percentage}}</span>-->
      </template>
      <template v-slot:cell(final_emailed_docs)="data">
        <span>{{ data.item.total.final_emailed_docs.value }} </span>
      </template>
      <template v-slot:cell(final_faxed_docs)="data">
        <span>{{ data.item.total.final_faxed_docs.value }} </span>
      </template>
      <template v-slot:cell(final_posted_docs)="data">
        <span>{{ data.item.total.final_posted_docs.value }} </span>
      </template>
      <template v-slot:cell(final_online_docs)="data">
        <span>{{ data.item.total.final_online_docs.value }} </span>
      </template>
      <template v-slot:cell(deleted_docs)="data">
        <span>{{ data.item.total.deleted_docs.value }} </span>
      </template>
      <template v-slot:cell(final_total_docs)="data">
        <span>{{ data.item.total.final_total_docs.value }} </span>
      </template>
      <template v-slot:cell(final_failed_dataxferred_docs)="data">
        <span>{{ data.item.total.final_failed_dataxferred_docs.value }} </span>
      </template>
      <template v-slot:cell(final_failed_emailed_docs)="data">
        <span>{{ data.item.total.final_failed_emailed_docs.value }} </span>
      </template>
      <template v-slot:cell(final_failed_faxed_docs)="data">
        <span>{{ data.item.total.final_failed_faxed_docs.value }} </span>
      </template>
      <template v-slot:cell(final_failed_total_docs)="data">
        <span>{{ data.item.total.final_failed_total_docs.value }} </span>
      </template>
      <template v-slot:cell(documents_link)="data">
        <span></span>
      </template>
      <template v-slot:cell(added_on)="data">
        <span>{{ t('uploadedOn', 'uploadedOn') }} </span> <span>{{ data.item.added_on | clientDateFormat(datePickerFormat) }}</span>
      </template>
      <template v-slot:row-details="row">
        <SubStatus v-if="row.item.sub_batch" :items="row.item.sub_batch"/>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'SubStatus',
  //this component inherits from the BatchStatus.vue component
  inject: [
    'batchRefTrim',
    'datePickerFormat'
  ],
  data () {
    return {
      items: [],
      subStartFields: [
        {key: 'id', label:'', thClass: 'd-none',
          tdClass: (value, key, item) => {
            switch(item.status) {
              case 'proof':
                return ['highlight-yellow', 'standard-cell-width-small', 'text-center']
              //break
              case 'approved':
                return ['highlight-green', 'standard-cell-width-small', 'text-center']
              //break
              case 'uploaded':
                return ['highlight-grey', 'standard-cell-width-small', 'text-center']
              //break
              case 'rejected':
                return ['highlight-red', 'standard-cell-width-small', 'text-center']
              //break
              default:
                return ['standard-cell-width-small', 'text-center']
            }
          }
        },
        {key: 'reference', label: '', thClass: 'd-none',
          tdClass: (value, key, item) => {
            switch(item.status) {
              case 'proof':
                return ['highlight-yellow', 'standard-cell-width-xl']
              //break
              case 'approved':
                return ['highlight-green', 'standard-cell-width-xl']
              //break
              case 'uploaded':
                return ['highlight-grey', 'standard-cell-width-xl']
              //break
              case 'rejected':
                return ['highlight-red', 'standard-cell-width-xl']
              //break
              default:
                return 'standard-cell-width-xl'
            }
          }
        },
        {key: 'start_dataxferred_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'start_emailed_docs', label: '', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'start_faxed_docs', label:'', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'start_posted_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'start_online_docs', label: '', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'deleted_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'start_total_docs', label:'', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        //{key: 'start_failed_dataxferred_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        //{key: 'start_failed_emailed_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        //{key: 'start_failed_faxed_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        //{key: 'start_failed_total_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']}
      ],
      subFinalFields: [
        {key: 'id', label:'', thClass: 'd-none',
          tdClass: (value, key, item) => {
            switch(item.status) {
              case 'proof':
                return ['highlight-yellow', 'standard-cell-width-small', 'text-center']
              //break
              case 'approved':
                return ['highlight-green', 'standard-cell-width-small', 'text-center']
              //break
              case 'uploaded':
                return ['highlight-grey', 'standard-cell-width-small', 'text-center']
              //break
              case 'rejected':
                return ['highlight-red', 'standard-cell-width-small', 'text-center']
              //break
              default:
                return ['standard-cell-width-small', 'text-center']
            }
          }
        },
        {key: 'reference', label: '', thClass: 'd-none',
          tdClass: (value, key, item) => {
            switch(item.status) {
              case 'proof':
                return ['highlight-yellow', 'standard-cell-width-xl']
              //break
              case 'approved':
                return ['highlight-green', 'standard-cell-width-xl']
              //break
              case 'uploaded':
                return ['highlight-grey', 'standard-cell-width-xl']
              //break
              case 'rejected':
                return ['highlight-red', 'standard-cell-width-xl']
              //break
              default:
                return 'standard-cell-width-xl'
            }
          }
        },
        {key: 'final_dataxferred_docs', label: '', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'final_emailed_docs', label: '', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'final_faxed_docs', label: '', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'final_posted_docs', label: '', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'final_online_docs', label: '', thClass: 'd-none', tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
        {key: 'deleted_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'final_total_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'final_failed_dataxferred_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'final_failed_emailed_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'final_failed_faxed_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']},
        {key: 'final_failed_total_docs', label: '', thClass: 'd-none', tdClass: ['standard-cell-width-small', 'text-center']}
      ]
    }
  },
  created() {
    this.items = this.$attrs.items
    this.tabIndex = this.$attrs.tabIndex
  },
  filters:{
    trimBatchReference: function(reference, batchRefTrim) {
      if (reference && reference !== '') {
        return reference.slice(0, batchRefTrim)
      }
    },
    clientDateFormat: function(date, datePickerFormat) {
      return moment(date).format(datePickerFormat + ' h:mm:ss')
    }
  }
}
</script>

<style scoped>
.showhand{
  cursor: pointer;
}

table >>> .highlight-yellow{
  background-color: #FFF176 !important;
}
table >>> .highlight-green{
  background-color: #DCE775 !important;
}
table >>> .highlight-grey{
  background-color: #E0E0E0 !important;
}
table >>> .highlight-red{
  background-color: #E57373 !important;
}
</style>
